/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams, LoadingController} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {BetDetailsPage} from "../betDetails/betDetails";
import {UserService} from "../../services/user.services";
import {BetDetailsBauCuaPage} from "../betDetailsBauCua/betDetailsBauCua";

@Component({
    templateUrl: 'userBetList.html',
    selector: 'agency-user-bet-list-page',
})
export class UserBetListPage {
    private recordList: any = [];
    private infiniteScrollBoolean: boolean = true;
    private totalNum: number = 0;
    requestData: any;
    tamount: any;
    twin: any;

    constructor(private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService, public viewCtrl: ViewController,
                private loadingCtrl: LoadingController) {
        this.requestData = navParams.get("requestData");
        this.loadingData(navParams.get("data"));
    }

    goDetail(index: string, lotteryID: number) {
        if (lotteryID === 92 || lotteryID === 93 || lotteryID === 94) {
            this.nav.push(BetDetailsBauCuaPage, {
                betID: index,
                gameID: lotteryID
            });
        }else {
            this.nav.push(BetDetailsPage, {
                revoke: true,
                betId: index
            });
        }
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        let dataParams = this.requestData;
        this.userService.gameRecordSearch(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.loadingData(data);
                if (refresher) {
                    refresher.complete();
                    this.infiniteScrollBoolean = true;
                }
            }
        });
    }

    doInfinite(infiniteScroll) {
        let dataParams = this.requestData;
        infiniteScroll.enable(false);
        setTimeout(() => {
            this.userService.gameRecordSearchNext(dataParams, this).then(data => {
                if (!data["msg"]) {
                    data["reslist"].map(item => {
                        item["bettime"] = item["bettime"].substr(0, 11);
                        return item;
                    });
                    this.recordList = this.recordList.concat(data["reslist"]);
                    this.totalNum = data["totalrecord"];
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }

    //更新加工数据
    loadingData(data: any) {
        this.recordList = data["reslist"];
        this.tamount = data["tamount"];
        this.twin = data["twin"];
        this.recordList.map(item => {
            item["bettime"] = item["bettime"].substr(0, 11);
            return item;
        });
        this.totalNum = data["totalrecord"];
    }
}



// WEBPACK FOOTER //
// ./src/pages/userBetList/userBetList.ts